import { ArrowBack, Check, Close } from '@mui/icons-material';
import { Chip, Stack, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from '../../../assets/customIcons';
import { ReactComponent as CloseIcon } from '../../../assets/images/closeIcon.svg';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { dateFormate } from '../../../utils/utils';
import { renderIcon } from '../../fieldFailureReports/components/CommonFunctions';
import { ViewPDICheckAPI } from '../services/apiCalls';
import ViewPDIQuestions from './viewPDIQuestions';
var ViewPDICheck = function (_ref) {
    var data = _ref.data, onClose = _ref.onClose;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var id = data === null || data === void 0 ? void 0 : data.id;
    console.log('Data CLg --', id);
    // const ViewPDIQueGroupElements: IDynamicFormBuilder['formData'] = [
    //     {
    //         type: FormItemTypes.Custom,
    //         name: 'Questions',
    //         element: ViewPDIQuestions,
    //         columnSize: 12
    //     }
    // ]
    var ViewPDIQueGroupElements = [{
            type: FormItemTypes.Custom,
            name: 'Questions',
            element: ViewPDIQuestions,
            columnSize: 12
        }];
    var ViewPDIQueGroupMobile = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            label: '',
            value: null,
            columnSize: 12,
            spacing: 0,
            p: '16px',
            elements: [{
                    type: FormItemTypes.List,
                    label: '',
                    name: 'Questions',
                    value: null,
                    variant: 'comfortable',
                    columnSize: 12,
                    rowHeight: 72,
                    disableCheckboxSelection: true,
                    columns: [{
                            field: 'Part',
                            flex: 1,
                            renderCell: function (params) {
                                var _params$row;
                                console.log('Params : Name : ', params);
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    variant: "h3"
                                }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.QuestionName));
                            }
                        }],
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: 'InspectionCriteria',
                            label: 'Inspection criteria',
                            disabled: true,
                            columnSize: 12
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'IssueDescription',
                            label: 'SOP',
                            disabled: true,
                            columnSize: 12
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            label: '',
                            value: null,
                            columnSize: 12,
                            setFieldProps: function (formValues, currValue, field) { return (console.log('Conatiner Pass Fail --', formValues === null || formValues === void 0 ? void 0 : formValues.InspectionResult), {
                                type: FormItemTypes.ContainerItem,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: '',
                                        label: 'Inspection Result',
                                        value: null,
                                        columnSize: 0,
                                        fontWeight: 'strong',
                                        fontSize: 'lg',
                                        labelTypographyProps: {
                                            paddingTop: 2
                                        }
                                    }, (formValues === null || formValues === void 0 ? void 0 : formValues.InspectionResult) == 1 ? {
                                        type: FormItemTypes.Button,
                                        name: '',
                                        variant: 'contained',
                                        children: 'Pass all',
                                        color: 'success',
                                        columnSize: 0,
                                        startIcon: /*#__PURE__*/ React.createElement(Check, null),
                                        sx: {
                                            mt: 1.5
                                        },
                                        setFieldProps: function (formValues, currValue) { return ({
                                            type: FormItemTypes.Button,
                                            display: (formValues === null || formValues === void 0 ? void 0 : formValues.InspectionResult) === 1 ? 'inline-flex' : 'none'
                                        }); }
                                    } : {
                                        type: FormItemTypes.Button,
                                        name: '',
                                        variant: 'contained',
                                        children: 'Fail all',
                                        color: 'error',
                                        columnSize: 0,
                                        startIcon: /*#__PURE__*/ React.createElement(Close, null),
                                        setFieldProps: function (formValues, currValue) { return (console.log('Inspection PAss ; ', formValues), {
                                            type: FormItemTypes.Button,
                                            display: (formValues === null || formValues === void 0 ? void 0 : formValues.InspectionResult) === 2 ? 'flex' : 'none'
                                        }); }
                                    }, {
                                        type: FormItemTypes.TextInput,
                                        name: 'Value',
                                        label: 'Actual value',
                                        disabled: true,
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.TextInput,
                                        name: 'Remarks',
                                        label: 'Remarks',
                                        disabled: true,
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.TextInput,
                                        name: 'CustomerVoiceName',
                                        label: 'Customer voice',
                                        disabled: true,
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.TextInput,
                                        name: 'ObservationName',
                                        label: 'Observation',
                                        disabled: true,
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.TextInput,
                                        name: 'DefectCategoryName',
                                        label: 'Defect category',
                                        disabled: true,
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.TextInput,
                                        name: 'ActionTakenName',
                                        label: 'Action taken',
                                        disabled: true,
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.TextInput,
                                        name: 'SAObservation',
                                        label: 'SA suggestion',
                                        disabled: true,
                                        columnSize: 12,
                                        multiline: true,
                                        minRows: 5
                                    }]
                            }); }
                        }]
                }]
        }];
    var formData = [isMobile ? {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            mt: 2,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: '',
                    columnSize: 12,
                    flexDirection: "row",
                    pl: 2,
                    item: false,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: "",
                            columnSize: 0,
                            onClick: function (e) {
                                onClose();
                            },
                            children: /*#__PURE__*/ React.createElement(ArrowBack, {
                                fontSize: "small"
                            })
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            flexDirection: 'column',
                            columnSize: true,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    children: "PDI check - ".concat(data === null || data === void 0 ? void 0 : data.DocumentNo),
                                    // value: `PDI check - ${data?.DocumentNo}`,
                                    fontWeight: 'strong',
                                    fontSize: 'xxl',
                                    columnSize: true
                                }]
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                color: "text.secondary",
                                height: '12px',
                                width: '12px'
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose();
                            }
                        }]
                }, IS_DESKTOP ? {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: 12,
                    item: false,
                    justifyContent: "end",
                    columns: 0,
                    // pt: '16px',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: '',
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'primary'
                        }]
                } : null]
        } : {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            mt: 2,
            flexDirection: 'row',
            justifyContent: 'space-between',
            paddingInline: '24px',
            alignItems: 'center',
            spacing: 0,
            columnGap: '16px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    columnSize: true,
                    display: "flex",
                    pl: 2,
                    item: false,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: "",
                            columnSize: 0,
                            onClick: function () {
                                onClose();
                            },
                            children: /*#__PURE__*/ React.createElement(ArrowBack, {
                                fontSize: "small"
                            })
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            flexDirection: 'column',
                            columnSize: 10,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    value: "PDI check - ".concat(data === null || data === void 0 ? void 0 : data.DocumentNo),
                                    fontWeight: 'strong',
                                    fontSize: 'lg',
                                    columnSize: true
                                }]
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: true,
                    item: false,
                    justifyContent: "end",
                    alignItems: 'center',
                    columns: 0,
                    spacing: 0,
                    columnGap: '10px',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            size: 'icon',
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            size: 'icon',
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            size: 'icon',
                            variant: "outlined",
                            color: 'secondary'
                        }]
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "text.secondary",
                        height: '12px',
                        width: '12px'
                    }),
                    columnSize: 0,
                    size: 'icon',
                    onClick: function () {
                        onClose(false);
                    }
                }]
        }, {
            type: FormItemTypes.Divider,
            name: '',
            columnSize: 12
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 2,
            paddingX: '24px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    spacing: 0,
                    gap: '6px',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'Document details',
                            columnSize: true,
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.CardComponent,
                            name: '',
                            sx: {
                                padding: '8px 12px'
                            },
                            contentProps: {
                                gap: '4px',
                                spacing: 0
                            },
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'DocumentNo',
                                    label: 'Doc no.',
                                    value: '',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1,
                                        spacing: 0
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'CreatedOn',
                                    label: 'Date :',
                                    value: '',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1,
                                        spacing: 0
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12,
                                    valueGetter: function (formData) {
                                        return dateFormate(formData === null || formData === void 0 ? void 0 : formData.CreatedOn);
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'CreatedBy',
                                    label: 'Created by:',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1,
                                        spacing: 0
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }]
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    spacing: 0,
                    gap: '6px',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'Basic details',
                            columnSize: true,
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.CardComponent,
                            name: '',
                            sx: {
                                padding: '8px 12px'
                            },
                            contentProps: {
                                gap: '4px',
                                spacing: 0
                            },
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'InspectorName',
                                    label: 'Service advisor',
                                    value: '',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1,
                                        spacing: 0
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'TechnicianName',
                                    label: 'Technician :',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1,
                                        spacing: 0
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'OdometerReading',
                                    label: 'Odometer reading:',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1,
                                        spacing: 0
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }]
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    spacing: 0,
                    gap: '6px',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'Vehicle details',
                            columnSize: true,
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.CardComponent,
                            name: '',
                            sx: {
                                padding: '8px 12px'
                            },
                            contentProps: {
                                gap: '4px',
                                spacing: 0
                            },
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'ModelName',
                                    label: 'Model :',
                                    value: '',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1,
                                        spacing: 0
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'PinNo',
                                    label: 'VIN No:',
                                    value: '',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1,
                                        spacing: 0
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'SerialNo',
                                    label: 'Engine No:',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 1,
                                        spacing: 0
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }]
                        }]
                }, IS_DESKTOP ? {
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    sx: {
                        borderRadius: '12px',
                        padding: 0
                    },
                    contentProps: {
                        spacing: 0
                    },
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            padding: '8px 12px',
                            columnGap: '20px',
                            alignItems: 'center',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    children: 'Inspection result',
                                    fontWeight: 'strong',
                                    columnSize: true,
                                    setFieldProps: function (formValues, currValue, field) {
                                        return {
                                            type: FormItemTypes.Typography
                                        };
                                    }
                                }]
                        }, {
                            type: FormItemTypes.Iterator,
                            name: 'PreDeliveryDetail',
                            columnSize: 12,
                            value: null,
                            elements: ViewPDIQueGroupElements,
                            containerProps: {
                                container: true,
                                spacing: 2
                            },
                            gridItemProps: {
                                xs: 12,
                                sm: 12,
                                md: 12,
                                lg: 12
                            }
                        }]
                } : {
                    type: FormItemTypes.CardComponent,
                    name: '',
                    // label: 'Inspection',
                    required: true,
                    value: null,
                    columnSize: 12,
                    sx: {
                        // bgcolor:'red',
                        p: '16px 0px 0px 0px !important'
                    },
                    labelTypographyProps: {},
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'Inspection result',
                            columnSize: 0,
                            sx: {
                                pl: 2,
                                fontWeight: 'medium',
                                fontSize: 'lg',
                                color: 'secondary.900'
                            }
                        }, {
                            type: FormItemTypes.List,
                            getRowId: function (row) { return row === null || row === void 0 ? void 0 : row.QuestionGroupId; },
                            name: 'PreDeliveryDetail',
                            value: null,
                            variant: 'compact',
                            disableCheckboxSelection: true,
                            columnSize: 12,
                            columns: [{
                                    field: 'Part',
                                    flex: 1,
                                    renderCell: function (_ref2) {
                                        var row = _ref2.row;
                                        console.log('Mobile View PDI Check : ', row);
                                        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Stack, {
                                            display: 'flex',
                                            flexDirection: 'row',
                                            gap: 1.5
                                        }, /*#__PURE__*/ React.createElement(Typography, {
                                            variant: "h3"
                                        }, row === null || row === void 0 ? void 0 : row.QuestionGroupName), /*#__PURE__*/ React.createElement(Stack, {
                                            display: 'flex',
                                            flexDirection: 'row',
                                            gap: 1.5
                                        }, /*#__PURE__*/ React.createElement(Chip, {
                                            label: (row === null || row === void 0 ? void 0 : row.FailCount) + (row === null || row === void 0 ? void 0 : row.PassCount),
                                            variant: "outlined",
                                            size: "small",
                                            color: "primary"
                                        }))));
                                    }
                                }],
                            elements: ViewPDIQueGroupMobile
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    name: '',
                    label: 'Additional info',
                    value: null,
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: "Remarks",
                            label: "Additional remarks",
                            value: null,
                            disabled: true,
                            labelTypographyProps: {
                                fontSize: "12px",
                                fontWeight: 500
                            },
                            // columnSize: 12,
                            sx: {
                                xs: 12,
                                sm: 12,
                                md: 12,
                                lg: 12
                            }
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    name: "",
                    value: null,
                    columnSize: 12,
                    variant: "outlined",
                    sx: {
                        mb: 2
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: "",
                            children: 'Attachments',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.List,
                            name: "Attachments",
                            label: 'Attachments',
                            value: null,
                            // columnSize: 12,
                            xs: 12,
                            sm: 12,
                            md: 12,
                            variant: 'comfortable',
                            columns: [{
                                    field: 'Icon',
                                    maxWidth: 40,
                                    renderCell: function (params) { return renderIcon(params.row.Name); }
                                }, {
                                    field: 'Name',
                                    flex: 1
                                }, {
                                    field: 'Size',
                                    width: 80
                                    // valueFormatter: (value: number) => `${Math?.round(value / 1000)?.toString()} KB`
                                }],
                            disableCheckboxSelection: true,
                            rowHeight: 72
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        gridProps: {
            spacing: 0,
            paddingTop: {
                xs: 0,
                sm: '70px'
                // md: '70px',
                // lg: '70px'
            },
            gap: '20px'
        },
        formData: formData,
        getFormAPI: ViewPDICheckAPI,
        getRequest: {
            id: id
        }
    }));
};
export default ViewPDICheck;
